import * as React from 'react';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withFormik, Field, FormikProps, Form } from 'formik';
import * as Yup from 'yup';

import FormikTextField from '../../common/formik/formik-text-field';
import axios from '../../common/axios-instance/axios-instance';
import { IStore } from '../../modules/root-reducer';
import * as actions from '../../modules/popup/action';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { AxiosResponse, AxiosError } from 'axios';

type ChangePasswordFormProps = IStateProps & IDispatchProps;

interface IChangePasswordFormValues {
  oldPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
}

interface IChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

const formikEnhancer = withFormik<
  ChangePasswordFormProps,
  IChangePasswordFormValues
>({
  validationSchema: Yup.object().shape({
    oldPassword: Yup.string().required('You must enter your old password'),
    newPassword: Yup.string().required('You must enter your old password'),
    newPasswordConfirm: Yup.string()
      .oneOf([Yup.ref('newPassword')], 'Passwords must match')
      .required('You must confirm your old password')
  }),

  mapPropsToValues: () => ({
    oldPassword: '',
    newPassword: '',
    newPasswordConfirm: ''
  }),
  handleSubmit: (
    values,
    { setSubmitting, setFieldError, resetForm, props }
  ) => {
    const passwordRequest: IChangePasswordRequest = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword
    };

    return axios
      .post<boolean>('/api/user/changePassword', passwordRequest)
      .then((res: AxiosResponse<boolean>) => {
        if (res.data === true) {
          resetForm();
          props.close();
        } else {
          throw res;
        }
        /* istanbul ignore next */
        setSubmitting(false);
      })
      .catch((error: AxiosError) => {
        console.log(error);
        setFieldError('newPasswordConfirm', 'The password was not changed');
        setSubmitting(false);
      });
  },
  enableReinitialize: true,
  displayName: 'PasswordChangeForm'
});

const styles = ({ spacing }: Theme) =>
  createStyles({
    button: {
      margin: spacing.unit
    }
  });

const ChangePassword = (
  props: FormikProps<IChangePasswordFormValues> &
    ChangePasswordFormProps &
    WithStyles<typeof styles>
) => {
  const { open, close, classes, resetForm } = props;

  const handleClose = () => {
    resetForm();
    close();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <Form>
          <div>
            <Field
              id="old-password-input"
              fullWidth
              name="oldPassword"
              label="Old Password"
              component={FormikTextField}
              type="password"
            />
          </div>
          <div>
            <Field
              id="new-password-input"
              fullWidth
              name="newPassword"
              label="New Password"
              component={FormikTextField}
              type="password"
            />
          </div>
          <div>
            <Field
              id="new-password-confirm-input"
              fullWidth
              name="newPasswordConfirm"
              label="Confirm New Password"
              component={FormikTextField}
              type="password"
            />
          </div>
          <Button
            onClick={close}
            variant="contained"
            color="default"
            className={classes.button}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
          >
            Save
          </Button>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

interface IStateProps {
  open: boolean;
}

const mapStateToProps = (state: IStore) => ({
  open: state.popupReducer.changePasswordOpen
});

interface IDispatchProps {
  close: () => actions.ICloseChangePassword;
}

const mapDispatchToProps = (dispatch: Dispatch<actions.PopupAction>) => {
  return bindActionCreators({ close: actions.closeChangePassword }, dispatch);
};

const enhance = compose(
  connect<IStateProps, IDispatchProps, {}, IStore>(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles),
  formikEnhancer
);

export default enhance(ChangePassword);



// WEBPACK FOOTER //
// ./src/features/change-password/change-password.tsx